module.exports = __webpack_public_path__ + "static/media/draw-data.5ff1f6f4.svg";